import { FaEdit, FaTrash, FaCheck, FaTimes } from 'react-icons/fa';
import { DialogTrigger } from '../ui/dialog';
import { Checkbox } from '../ui/checkbox';
import { PERIODICIDADES, MESES, DIAS_SEMANA, descricaoAviso } from './periodicidades';

const classeCampo = 'bg-gray-800 text-white text-sm border border-gray-700 rounded px-1 py-1 disabled:opacity-50';

function CamposAviso({ periodicidade, valores, salvando, onChangeValor }) {
    if (periodicidade === 'Programada') {
        return (
            <label className="flex flex-col items-center gap-0.5 text-sm text-gray-400 w-full">
                <input
                    type="date"
                    required
                    disabled={salvando}
                    value={valores.dataProgramada ?? ''}
                    onChange={(e) => onChangeValor('dataProgramada', e.target.value)}
                    className={`w-full ${classeCampo}`}
                />
                data
            </label>
        );
    }

    if (periodicidade === 'Semanal') {
        return (
            <label className="flex flex-col items-center gap-0.5 text-sm text-gray-400 w-full">
                <select
                    disabled={salvando}
                    value={valores.diaAviso ?? ''}
                    onChange={(e) => onChangeValor('diaAviso', e.target.value)}
                    className={`w-full ${classeCampo}`}
                >
                    <option value="">dia</option>
                    {DIAS_SEMANA.map((d, i) => <option key={d} value={i + 1}>{d}</option>)}
                </select>
                aviso (opcional)
            </label>
        );
    }

    if (!['Mensal', 'Semestral', 'Anual'].includes(periodicidade)) return null;

    const meses = periodicidade === 'Semestral'
        ? MESES.slice(0, 6).map((m, i) => ({ valor: i + 1, nome: `${m}/${MESES[i + 6]}` }))
        : MESES.map((m, i) => ({ valor: i + 1, nome: m }));

    return (
        <label className="flex flex-col items-center gap-0.5 text-sm text-gray-400 w-full">
            <div className="flex gap-1 w-full justify-center">
                <input
                    type="number"
                    min={1}
                    max={31}
                    placeholder="dia"
                    disabled={salvando}
                    value={valores.diaAviso ?? ''}
                    onChange={(e) => onChangeValor('diaAviso', e.target.value)}
                    className={`w-12 text-center ${classeCampo}`}
                />
                {periodicidade !== 'Mensal' && (
                    <select
                        disabled={salvando}
                        value={valores.mesAviso ?? ''}
                        onChange={(e) => onChangeValor('mesAviso', e.target.value)}
                        className={classeCampo}
                    >
                        <option value="">mês</option>
                        {meses.map((m) => <option key={m.valor} value={m.valor}>{m.nome}</option>)}
                    </select>
                )}
            </div>
            aviso (opcional)
        </label>
    );
}

export default function LinhaItemManutencao({
    item,
    podeEditar,
    emEdicao,
    bloqueado,
    salvando,
    valores,
    onChangeValor,
    onEditar,
    onCancelar,
    onSalvar,
    onExcluir,
}) {
    if (emEdicao) {
        return (
            <tr className="border-b border-gray-800/40 align-top even:bg-white/5">
                <td className="p-2">
                    <textarea
                        className="w-full bg-darkaccent text-white rounded-md border border-gray-700 p-1 text-lg resize-y break-words scrollbar-thin scrollbar-track-primary scrollbar-thumb-darkaccent disabled:opacity-50"
                        rows={2}
                        maxLength={1000}
                        disabled={salvando}
                        value={valores.acao ?? ''}
                        onChange={(e) => onChangeValor('acao', e.target.value)}
                    />
                </td>
                {PERIODICIDADES.map((p) => (
                    <td key={p.valor} className="p-2 text-center">
                        <div className="flex flex-col items-center gap-1">
                            <Checkbox
                                className="h-5 w-5"
                                checked={valores.periodicidade === p.valor}
                                disabled={salvando}
                                onCheckedChange={(v) => {
                                    if (v !== true) return;
                                    onChangeValor('periodicidade', p.valor);
                                    onChangeValor('diaAviso', '');
                                    onChangeValor('mesAviso', '');
                                }}
                                aria-label={p.nome}
                            />
                            {valores.periodicidade === p.valor && (
                                <CamposAviso
                                    periodicidade={p.valor}
                                    valores={valores}
                                    salvando={salvando}
                                    onChangeValor={onChangeValor}
                                />
                            )}
                        </div>
                    </td>
                ))}
                {podeEditar && (
                    <td className="p-2 whitespace-nowrap">
                        <div className="flex gap-2 items-center justify-center">
                            <button type="button" onClick={onSalvar} disabled={salvando} title="Salvar" className="disabled:opacity-50">
                                <FaCheck className="text-green-400 h-5 w-5 cursor-pointer" />
                            </button>
                            <button type="button" onClick={onCancelar} disabled={salvando} title="Cancelar" className="disabled:opacity-50">
                                <FaTimes className="text-red-400 h-5 w-5 cursor-pointer" />
                            </button>
                        </div>
                    </td>
                )}
            </tr>
        );
    }

    return (
        <tr className="border-b border-gray-800/40 even:bg-white/5">
            <td className="p-2 text-lg whitespace-pre-wrap break-words">{item.acao}</td>
            {PERIODICIDADES.map((p) => (
                <td key={p.valor} className="p-2 text-center text-lg font-semibold">
                    {item.periodicidade === p.valor && (
                        <span>
                            X
                            {descricaoAviso(item) && (
                                <span className="block text-sm font-normal text-gray-400" title="Data do aviso">
                                    {descricaoAviso(item)}
                                </span>
                            )}
                            {!item.dataProgramada && p.valor === 'Programada' && (
                                <span className="block text-sm font-normal text-yellow-400" title="Defina a data para gerar a tarefa">
                                    definir data
                                </span>
                            )}
                        </span>
                    )}
                </td>
            ))}
            {podeEditar && (
                <td className="p-2 whitespace-nowrap">
                    <div className="flex gap-3 items-center justify-center">
                        <button
                            type="button"
                            onClick={() => onEditar(item)}
                            disabled={bloqueado}
                            title={bloqueado ? 'Finalize a edição em andamento' : 'Editar'}
                            className="disabled:opacity-30 disabled:cursor-not-allowed"
                        >
                            <FaEdit className="text-accent h-5 w-5 cursor-pointer" />
                        </button>
                        <DialogTrigger
                            onClick={() => !bloqueado && onExcluir(item)}
                            disabled={bloqueado}
                            title={bloqueado ? 'Finalize a edição em andamento' : 'Excluir'}
                            className="disabled:opacity-30 disabled:cursor-not-allowed"
                        >
                            <FaTrash className="text-red-400 h-5 w-5 cursor-pointer" />
                        </DialogTrigger>
                    </div>
                </td>
            )}
        </tr>
    );
}
